<template>
    <div class="page">
        <div class="header">
            <div class="logo">
                <img :src="icon" alt="" />
            </div>
            <div class="title">{{ title }}</div>
        </div>
        <div class="form">
            <div class="title">
                <img src="../../assets/my/in1.png" alt="" />
                <div class="name">账号</div>
            </div>
            <van-field
                class="input"
                v-model="form.phone"
                border
                placeholder="请输入账号"
            />
            <div class="title password">
                <img src="../../assets/my/in2.png" alt="" />
                <div class="name">密码</div>
            </div>
            <van-field
                class="input"
                type="password"
                v-model="form.password"
                border
                placeholder="请输入密码"
            />

            <div class="radio">
                <van-checkbox v-model="checked" icon-size="15px">
                    <div class="tips">
                        我已同意接受 <span>用户协议</span> 和
                        <span>隐私政策</span>
                    </div>
                </van-checkbox>
            </div>
            <van-button
                class="button"
                :loading="button.loading"
                :disabled="button.disabled"
                @click="submit"
                :loading-text="button.text"
            >
                {{ button.text }}
            </van-button>
        </div>
    </div>
</template>

<script>
import { getCookie, setCookie } from "@/utils";
import { tenantLogin } from "@/api/tenant";
import { Toast } from "vant";
export default {
    data() {
        return {
            button: { loading: false, disable: false, text: "登 录" },
            form: {
                phone: "", 
                password: "",
            },
            checked: false,
            title: "",
            icon: ""
        };
    },
    created() {
        console.log(process.env);
        // 在 created 生命周期中设置环境变量
        this.title = process.env.VUE_APP_APP_NAME || "";
        this.icon = require(`../../assets/images/${process.env.VUE_APP_APP_ICON}`);
        let token = getCookie("tenant_personbench_token");
        if (token) {
            this.$router.push("/double/list");
        }
    },
    methods: {
        submit() {
            if (this.form.phone === "") {
                return Toast({ position: "top", message: "请输入账号" });
            }
            if (this.form.password === "") {
                return Toast({ position: "top", message: "请输入密码" });
            }
            if (!this.checked) {
                return Toast({
                    position: "top",
                    message: "请先同意用户协议和隐私政策",
                });
            }
            this.button.disabled = true;
            this.button.loading = true;
            this.button.text = "登录中...";
            tenantLogin(this.form)
                .then((res) => {
                    if (res.code == 1) {
                        res.data.isDealer = res.data.role == 1;
                        setCookie("tenant_personbench_token", res.data.token);
                        setCookie("tenant_person", JSON.stringify(res.data.user_info));
                        localStorage.setItem(
                            "tenant_user",
                            JSON.stringify(res.data.user_info)
                        );
                        this.$router.push({
                            name: "doubleList",
                        });
                    } else {
                        Toast.fail(res.message);
                    }
                })
                .finally((e) => {
                    this.button.disabled = false;
                    this.button.loading = false;
                    this.button.text = "登 录";
                });
        },
    },
};
</script>

<style scoped lang="less">
.page {
    min-height: 100vh;
    width: 100%;
    background: #2b62cc;
    padding-top: var(--base-px-55);
    display: flex;
    flex-direction: column;
}

.page .header {
    height: var(--base-px-178);
    text-align: center;
    flex-shrink: 0;
}

.page .header .logo img {
    width: var(--base-px-70);
    height: var(--base-px-70);
    border-radius: var(--base-px-10);
}

.page .header .title {
    margin-top: var(--base-px-15);
    color: #ffffff;
    font-weight: bold;
    font-size: var(--base-px-20);
}

.page .form {
    background: #ffffff;
    border-radius: var(--base-px-35) var(--base-px-35) 0 0;
    position: relative;
    overflow: hidden;
    flex: 1;
    padding: var(--base-px-50) var(--base-px-25) var(--base-px-25);
    display: flex;
    flex-direction: column;
}
.page .form .title {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: flex-start;
    font-size: var(--base-px-14);
    /*font-weight: bold;*/
    margin-bottom: var(--base-px-10);
}
.page .form .title.password {
    margin-top: var(--base-px-25);
}
.page .form .title img {
    width: var(--base-px-12);
    margin-right: var(--base-px-5);
}
.page .form .input {
    height: var(--base-px-45);
    background: #f5f7f7;
    border-radius: var(--base-px-24);
}
.page .form .radio {
    margin-left: var(--base-px-10);
    margin-top: var(--base-px-85);
}
.page .form .tips {
    font-size: var(--base-px-12);
    font-weight: 400;
    color: #666666;
}
.page .form .tips span {
    color: #117de9;
}
.page .form .button {
    width: 100%;
    background: linear-gradient(to right, #117de9, #2b62cc);
    color: #ffffff;
    font-weight: bold;
    border-radius: var(--base-px-30);
    margin-top: var(--base-px-15);
}
</style>
